<template>
  <b-container>
    <b-breadcrumb :items="items" @click="navigate"></b-breadcrumb>
    <!-- <b-form-group label="Select Report Category" label-size="sm"> -->
    <b-row>
      <b-col md="3">
        <b-form-group
          id="exampleInputGroup2"
          label="Report Category"
          label-size="sm"
          label-for="radiosg"
        >
          <b-form-radio-group
            id="ragiosg"
            v-model="selected"
            :options="MainList"
            value-field="CategoryID"
            text-field="Category"
            class="mb-3"
            disabled-field="notEnabled"
            @change.native="onChange"
            stacked
            size="sm"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
      <!-- </b-form-group> -->
      <b-col md="8">
        <div class="row">
          <b-col>
            <b-form-group
              id="grp1"
              label-cols="2"
              label="Report Name:"
              label-size="sm"
              label-for="ipReport"
              v-if="show"
            >
              <b-select
                id="ipReport"
                value-field="ReportID"
                size="sm"
                text-field="ReportName"
                :options="subarray"
                v-model="output.ReportID"
                @change.native="onReportChange"
              ></b-select>
            </b-form-group>
          </b-col>
          <!-- <div class="form-group col-md-12" style="padding:0" v-if="show">
            <label for="inputUser3" style="margin-top:5px" class="col-sm-2">Report Name</label>
            <div class="col-sm-9">
              <select
                v-model="output.ReportID"
                class="form-control toli_id"
                data-placeholder
                tabindex="1"
                id="bank"
                name="bank"
                @change="onReportChange"
                style="border-radius:5px"
              >
                <option
                  v-for="(arrid, index) in subarray"
                  :value="arrid.ReportID"
                  :key="index"
                >{{arrid.ReportName}}</option>
              </select>
            </div>
          </div>-->
        </div>
        <hr v-if="show" />
        <b-row>
          <b-col md="12">
            <form-generator :schema="schema" v-if="show" v-model="formData"></form-generator>
          </b-col>
        </b-row>
        <div class="row">
          <div class="col-md-12">
            <b-btn
              variant="success"
              size="sm"
              text="View Report"
              @click="showReport"
              style="float:right"
              v-if="show"
            >View Report</b-btn>
            <b-btn
              variant="secondary"
              size="sm"
              text="View Report"
              @click="reset"
              style="float:right"
              class="mx-3"
              v-if="show"
            >Reset</b-btn>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import apis from "@/apis";
import Vue from "vue";
import * as _ from "lodash";
import FormGenerator from "@/components/Generator/FormGenerator";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import logger from "@/utils/logger";
import { normalizeResponseArray } from "@/utils/responseNormalizer";
//import "vue2-datepicker/index.scss";
const base_url = process.env.VUE_APP_BASE_URL;
export default {
  props: ["mainCategory", "initialCategoryId", "initialReportId"],
  components: { FormGenerator, DatePicker },
  data() {
    return {
      show: false,
      selected: "",
      selectedReport: "",
      initialSelectionApplied: false,
      items: [],
      schema: [],
      formData: {},
      output: {
        BoardID: 1,
        ReportID: 0,
        ReportFilter: {}
      },
      fields: [],
      itemsTemplate: [
        {
          text: "All",
          href: "#",
          cat: 0
        }
      ],
      MainList: [],
      MainListTemplate: [],
      subarray: [],
      SubList: [],
      CategoryID: "",
      SubList: []
    };
  },
  mounted() {
    this.get_mainList();
    // this.MainList = this.MainListTemplate.Category;
  },
  methods: {
    get_mainList() {
      this.items = JSON.parse(JSON.stringify(this.itemsTemplate));
      this.get_child_list(this.mainCategory);
    },
    get_child_list: function(val) {
      let promise = apis.GetReportCategory({ CategoryID: val });
      return promise
        .then(response => {
          if (response.status == 200) {
            let obj = normalizeResponseArray(response);
            if (obj.length > 0) {
              this.MainList = obj;
            } else {
              this.MainList = [];
            }
          }
          this.maybeApplyInitialSelection();
        })
        .catch(err => {
          logger.error(err);
          alert("ERROR");
        });
    },
    maybeApplyInitialSelection() {
      if (this.initialSelectionApplied || !this.initialCategoryId) return;
      this.initialSelectionApplied = true;
      this.selected = Number(this.initialCategoryId);
      this.get_report_list(this.initialCategoryId).then(() => {
        this.show = true;
        if (this.initialReportId) {
          this.output.ReportID = Number(this.initialReportId);
          this.get_schema(this.output.ReportID, "report");
        }
      });
    },
    get_report_list(val) {
      let promise = apis.GetReportMaster({ CategoryID: val });

      return promise
        .then(response => {
          if (response.status == 200) {
            let obj = normalizeResponseArray(response);
            if (obj.length > 0) {
              this.subarray = obj;
              this.subarray.splice(0, 0, { ReportID: 0, ReportName: "Select" });
              this.output.ReportID = 0;
            } else {
              this.subarray = [];
            }
          }
        })
        .catch(err => {
          logger.error(err);
          alert("ERROR");
        });
    },
    get_schema(val, typ) {
      this.output.ReportFilter = {};
      this.schema = [];
      this.formData={};
      let promise;
      if (typ == "category") {
        //promise = apis.get_report_schema({ CategoryID: val });
        return;
      } else {
        promise = apis.GetReportParameters({
          CategoryID: val
        });
      }

      promise
        .then(response => {
          if (response.status == 200) {
            let obj = normalizeResponseArray(response);
            if (obj) {
              for (var i = 0; i < obj.length; i++) {
                if (
                  obj[i].fieldType == "SelectList" &&
                  obj[i].selectOptionsAPI != null
                ) {
                  obj[i].options = this.$store.getters.getDynamicValues(
                    obj[i].selectOptionsAPI
                  );
                  //we are not passing API link in the schema; we are refferring to objects in the store
                } else if (obj[i].fieldType == "SelectList") {
                  obj[i].options = JSON.parse(obj[i].selectOptions);
                }
                this.schema.push(obj[i]);
              }
              this.schema = this.addCustomReportFilters(val, this.schema, this.getReportNameById(val));
              this.applyAllDefaults(this.schema);
            }
          }
        })
        .catch(err => {
          alert("ERROR");
        });
    },
    getReportNameById(reportId) {
      const match = _.filter(this.subarray, { ReportID: reportId })[0];
      return match ? match.ReportName : "";
    },
    isClaimReport(reportId, reportName) {
      const normalizedName = String(reportName || "").toLowerCase();
      return (
        reportId == 24 ||
        reportId == 25 ||
        normalizedName.indexOf("claim") !== -1 ||
        normalizedName.indexOf("subsidy") !== -1 ||
        normalizedName.indexOf("interest") !== -1 ||
        normalizedName.indexOf("passbook") !== -1
      );
    },
    addCustomReportFilters(reportId, schema, reportName) {
      const baseFilters = [
        {
          fieldType: "DateInput",
          label: "From Date",
          name: "from_date",
          valueType: "format",
          type: "date"
        },
        {
          fieldType: "DateInput",
          label: "To Date",
          name: "to_date",
          valueType: "format",
          type: "date"
        }
      ];

      const claimFilters = [
        {
          fieldType: "TextInput",
          label: "Beneficiary Name",
          name: "beneficiary_name",
          type: "text",
          placeholder: "Enter beneficiary name"
        },
        {
          fieldType: "TextInput",
          label: "Claim Number",
          name: "claim_number",
          type: "text",
          placeholder: "Enter claim number"
        },
        {
          fieldType: "TextInput",
          label: "Office",
          name: "office_name",
          type: "text",
          placeholder: "Enter office name"
        },
        {
          fieldType: "TextInput",
          label: "District",
          name: "district_name",
          type: "text",
          placeholder: "Enter district name"
        },
        {
          fieldType: "NumberInput",
          label: "Amount From",
          name: "amount_from",
          placeholder: "Min amount"
        },
        {
          fieldType: "NumberInput",
          label: "Amount To",
          name: "amount_to",
          placeholder: "Max amount"
        },
        {
          fieldType: "SelectList",
          label: "Report View",
          name: "report_view",
          options: [
            { value: "beneficiary", text: "Beneficiary-wise Detailed" },
            { value: "beneficiary_summary", text: "Beneficiary-wise Summary" },
            { value: "passbook", text: "Bank Passbook Style" },
            { value: "scheme", text: "Scheme-wise" },
            { value: "district", text: "District-wise" }
          ],
          optionsValueField: "value",
          optionsTextField: "text"
        },
        {
          fieldType: "SelectList",
          label: "Validation Mode",
          name: "validation_mode",
          options: [
            { value: "all", text: "All Records" },
            { value: "validated", text: "Validated Only" },
            { value: "mismatch", text: "Mismatches Only" }
          ],
          optionsValueField: "value",
          optionsTextField: "text"
        }
      ];

      const normalizedName = String(reportName || "").toLowerCase();
      const isLoiReport = normalizedName.indexOf("loi") !== -1 || normalizedName.indexOf("letter of intent") !== -1;

      const loiFilters = [
        {
          fieldType: "SelectList",
          label: "LOI Period Type",
          name: "loi_period_type",
          options: [
            { value: "date", text: "Date Range" },
            { value: "month", text: "Month Wise" },
            { value: "year", text: "Year Wise" }
          ],
          optionsValueField: "value",
          optionsTextField: "text"
        },
        {
          fieldType: "DateInput",
          label: "LOI Month",
          name: "report_month",
          valueType: "format",
          type: "month"
        },
        {
          fieldType: "SelectList",
          label: "Financial Year",
          name: "financial_year",
          options: (this.$store.state.fyList || []).map((x) => ({ value: x.fy, text: x.fy })),
          optionsValueField: "value",
          optionsTextField: "text"
        },
        {
          fieldType: "DateInput",
          label: "From Date",
          name: "from_date",
          valueType: "format",
          type: "date"
        },
        {
          fieldType: "DateInput",
          label: "To Date",
          name: "to_date",
          valueType: "format",
          type: "date"
        }
      ];

      if (isLoiReport) {
        return loiFilters.concat(schema);
      }

      if (this.isClaimReport(reportId, reportName)) {
        return baseFilters.concat(claimFilters, schema);
      }

      return baseFilters.concat(schema);
    },
    getOptionText(option, field) {
      if (!option || typeof option !== "object") return "";
      const textField = field.optionsTextField || "text";
      if (option[textField] !== undefined && option[textField] !== null) {
        return String(option[textField]);
      }
      if (option.text !== undefined && option.text !== null) return String(option.text);
      if (option.label !== undefined && option.label !== null) return String(option.label);
      if (option.name !== undefined && option.name !== null) return String(option.name);
      if (option.DistName !== undefined && option.DistName !== null) return String(option.DistName);
      if (option.ApplicationStatus !== undefined && option.ApplicationStatus !== null) return String(option.ApplicationStatus);
      if (option.Region !== undefined && option.Region !== null) return String(option.Region);
      return "";
    },
    getOptionValue(option, field) {
      if (!option || typeof option !== "object") return option;
      const valueField = field.optionsValueField || "value";
      if (option[valueField] !== undefined && option[valueField] !== null) {
        return option[valueField];
      }
      if (option.value !== undefined) return option.value;
      if (option.Id !== undefined) return option.Id;
      if (option.ID !== undefined) return option.ID;
      if (option.DistID !== undefined) return option.DistID;
      if (option.RegionID !== undefined) return option.RegionID;
      return option;
    },
    applyAllDefaults(fields) {
      (fields || []).forEach((field) => {
        if (!field || field.fieldType !== "SelectList" || !Array.isArray(field.options)) {
          return;
        }

        const currentValue = this.formData[field.name];
        if (currentValue !== undefined && currentValue !== null && String(currentValue).trim() !== "") {
          return;
        }

        const allOption = field.options.find((option) => {
          const text = this.getOptionText(option, field).trim().toLowerCase();
          return text === "all" || text.indexOf("all ") === 0 || text.indexOf(" all") !== -1;
        });

        if (allOption) {
          this.$set(this.formData, field.name, this.getOptionValue(allOption, field));
        }
      });
    },
    reset(evt) {
      evt.preventDefault();
      //let tempschema = this.selectedReport;
      this.formData={};
      
      // for (var x in this.formData) {
      //   this.formData[x] = null;
      // }
      this.schema = [];
      this.output.ReportFilter = {};
      //this.get_schema(this.selected, "category");
      this.get_schema(this.output.ReportID, "report");
    },
    showReport(evt) {
      evt.preventDefault();
      //this.$router.push("/report");
      let reportName = _.filter(this.subarray, {
        ReportID: this.output.ReportID
      })[0].ReportName;

      // this.output.having_para = [];
      // this.output.where_para = [];
      // for (let x in this.formData) {
      //   let key = x;
      //   let val = this.formData[x];
      //   let obj = _.filter(this.schema, { name: key })[0];
      //   if (obj.HavingFlag) {
      //     this.output.having_para.push({
      //       field_name: obj.db_field,
      //       condition: obj.compareSign, //between, in, <>, >, <
      //       value: val,
      //       start_value: "",
      //       end_value: "",
      //       arrayValue: [],
      //       table_name: obj.table_name,
      //       replace_alias: obj.replace_alias,
      //       id: obj.CategoryFilterID
      //     });
      //   } else {
      //     this.output.where_para.push({
      //       field_name: obj.db_field,
      //       condition: obj.compareSign, //between, in, <>, >, <
      //       value: val,
      //       start_value: "",
      //       end_value: "",
      //       arrayValue: [],
      //       table_name: obj.table_name,
      //       replace_alias: obj.replace_alias,
      //       id: obj.CategoryFilterID
      //     });
      //   }
      // }
      this.output.ReportFilter = this.formData;
      if (this.isClaimReport(this.output.ReportID, reportName)) {
        this.output.ReportFilter.report_family = "claim";
        this.output.ReportFilter.beneficiary_name = this.formData.beneficiary_name || "";
        this.output.ReportFilter.claim_number = this.formData.claim_number || "";
        this.output.ReportFilter.office_name = this.formData.office_name || "";
        this.output.ReportFilter.district_name = this.formData.district_name || "";
        this.output.ReportFilter.amount_from = this.formData.amount_from || "";
        this.output.ReportFilter.amount_to = this.formData.amount_to || "";
        this.output.ReportFilter.report_view = this.formData.report_view || "beneficiary";
        this.output.ReportFilter.validation_mode = this.formData.validation_mode || "all";
        this.output.ReportFilter.from_date = this.formData.from_date || "";
        this.output.ReportFilter.to_date = this.formData.to_date || "";
      }
      if (reportName && (String(reportName).toLowerCase().indexOf("loi") !== -1 || String(reportName).toLowerCase().indexOf("letter of intent") !== -1)) {
        this.output.ReportFilter.loi_period_type = this.formData.loi_period_type || "date";
        this.output.ReportFilter.report_month = this.formData.report_month || "";
        this.output.ReportFilter.financial_year = this.formData.financial_year || "";
        this.output.ReportFilter.from_date = this.formData.from_date || "";
        this.output.ReportFilter.to_date = this.formData.to_date || "";
      }
      if (this.output.ReportID == 24 || this.output.ReportID == 25) {
        this.output.ReportFilter.financial_year = this.formData.financial_year || "";
      }
      
      this.$store.dispatch("setReportQuery", this.output);
      this.$store.dispatch("setReportName", reportName);
      this.$emit("clicked");
    },
    onChange(evt) {
      let val = evt.target.value;
      let obj = _.filter(this.MainList, { CategoryID: parseInt(val) })[0];
      this.schema = [];

      if (obj) {
        if (obj.IsLast) {
          //this.subarray = obj.SubList;
          this.get_report_list(val);
          //this.schema = obj.filterCriteria;
          //this.get_schema(val, "category");
          this.show = true;
        } else {
          this.subarray = [];
          this.items.push({
            text: obj.Category,
            href: "#",
            cat: val
          });
          this.schema = [];
          this.show = false;
          this.get_child_list(val);
        }
      }

      //let obj = _.filter(this.SubList, { MainList: val })[0];
      //console.log(obj);
    },
    onReportChange(evt) {
      evt.preventDefault();

      let val = evt.target.value;
      this.get_schema(val, "report");
    },
    navigate(evt) {
      let val = evt.target.text;
      this.show = false;
      this.subarray = [];
      this.schema = [];
      this.selected = "";
      this.selectedReport = "";

      if (val == "All") {
        //this.items = JSON.parse(JSON.stringify(this.itemsTemplate));
        //this.MainList = JSON.parse(JSON.stringify(this.MainListTemplate));

        this.get_mainList();
      } else {
        let i = _.findIndex(this.items, { text: val });
        this.items.splice(i + 1, this.items.length - (i + 1));

        this.get_child_list(this.items[i].cat);
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ReportViewer/ReportsQuery.vue